import moment from 'moment'

export default {
  computed: {
    time () {
      return moment(this.transaction.order_at).format('YYYY-MM-DD HH:mm')
    },
  }
}
